


















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {email, required} from 'vee-validate/dist/rules';
import {
  SolarEmailSimilarity
} from "../../../../../../../vendor/happy-horizon/solar-email-similarity/resources/resources/assets/js";

extend('required', required);
extend('email', email);

@Component({
  name: 'login',
  components: {
    ValidationProvider,
    ValidationObserver
  }
})

export default class extends Vue {
  @Prop({required: true}) private postRoute: string;
  @Prop({required: true}) private passwordForgetRoute: string;
  @Prop({required: true}) private csrfToken: string;
  @Prop({default: ''}) private oldUsername: string;

  private login: object = {username: null, password: null};

  private mounted(): void {
    new SolarEmailSimilarity({
      'message': this.$t('Did you mean {email}?')
    });
  }

  private created(): void {
    if(this.oldUsername) {
      this.login = {
        username: this.oldUsername,
        password: null
      };
    }
  }}
